import APIUtils from '@spothero/utils/api';

const ContentAPI = {
    getNavigation() {
        return APIUtils.get('cms/menus/header-menu/');
    },

    getFooter() {
        return APIUtils.get('cms/menus/footer-menu/');
    },
};

export default ContentAPI;
